import { connect, type MapStateToProps } from 'react-redux';
import { type State } from '../../../state/types';
import CreatePageError from './index';
import { getProjectId, getProjectType } from '../../../state/project/selectors';
import { type StateProps, type Props } from './types';

const mapStateToProps: MapStateToProps<StateProps, Props, State> = (state: State) => ({
	projectId: getProjectId(state),
	projectType: getProjectType(state),
});

export default connect<StateProps, {}, Props, State>(mapStateToProps)(CreatePageError);
